/* Assassin Workshop — moteur global d'animations premium */
(() => {
  'use strict';
  if (window.AWAnimations?.version) return;
  const root = document.documentElement;
  const runtimeScript = document.currentScript;

  /* P1 — Modèle / Plateforme / Marque : charge l'index Compatibility uniquement
     lorsqu'un graphe P1 est réellement présent. Les URLs sœurs restent attachées
     au même thème preview, sans hardcoder de domaine, d'ID de thème ni de CDN. */
  const awSiblingAssetUrl = (filename) => {
    const source = String(runtimeScript?.src || '').trim();
    if (!source || !filename) return '';
    try {
      const url = new URL(source, window.location.href);
      if (!/\/assets\/[^/]+$/.test(url.pathname)) return '';
      url.pathname = url.pathname.replace(/\/assets\/[^/]+$/, `/assets/${filename}`);
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (_) {
      return '';
    }
  };

  const loadP1CompatibilityGraph = () => {
    const selector = '[data-aw-p1-model-graph],[data-aw-p1-platform-graph],[data-aw-p1-brand-graph]';
    if (!document.querySelector(selector)) return;
    if (window.AWP1CompatibilityIndex?.version || document.querySelector('script[data-aw-p1-compat-loader]')) return;

    const src = awSiblingAssetUrl('aw-compatibility-relation-index-p1.js');
    const relationSource = awSiblingAssetUrl('aw-compatibility-relation-source-public.jsonl');
    const modelSource = awSiblingAssetUrl('aw-replica-model-index.jsonl');
    if (!src || !relationSource) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.awP1CompatLoader = 'true';
    script.dataset.awRelationSource = relationSource;
    if (modelSource) script.dataset.awModelSource = modelSource;
    script.onerror = () => {
      document.documentElement.dataset.awP1CompatibilityIndex = 'loader-error';
    };
    document.head.appendChild(script);
  };

  /* Le lecteur P1 reconstruit Variantes/Compatibility après le Liquid. Cette passe
     remet explicitement Variantes avant la couche Produits sur Plateforme/Marque
     si de vraies ProductVariant sont documentées plus tard. */
  const awFindGraphGroup = (scope, heading) => Array.from(scope.querySelectorAll('.aw-p1-graph__group')).find((group) =>
    String(group.querySelector('h3')?.textContent || '').trim() === heading
  );
  const orderP1GraphLayers = () => {
    document.querySelectorAll('[data-aw-p1-platform-graph]').forEach((scope) => {
      const variants = awFindGraphGroup(scope, 'Variantes documentées');
      const products = awFindGraphGroup(scope, 'Produits reliés à la plateforme');
      if (variants && products && variants.nextElementSibling !== products) products.before(variants);
    });
    document.querySelectorAll('[data-aw-p1-brand-graph]').forEach((scope) => {
      const variants = awFindGraphGroup(scope, 'Variantes documentées');
      const products = scope.querySelector('[data-aw-p1-brand-products-bridge]');
      if (variants && products && variants.nextElementSibling !== products) products.before(variants);
    });
  };
  window.addEventListener('aw:p1-compatibility-index-ready', orderP1GraphLayers);

  loadP1CompatibilityGraph();

  /* Lighthouse/mobile : conserver l'interface immédiate et supprimer le coût des
     révélations/hover JS sur petits écrans. Les animations Hero ont leur propre
     contrôleur et ne dépendent pas de ce moteur global. */
  if (window.matchMedia('(max-width: 749px)').matches) {
    root.classList.remove('no-js');
    root.classList.add('js');
    window.AWAnimations = {
      refresh: () => {},
      reveal: (element) => element?.classList.add('is-visible')
    };
    return;
  }

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = '.aw-reveal, [data-aw-reveal]';
  const commonRevealSelector = [
    '.section-heading', '.category-card', '.product-card', '.product-card-v3', '.usp',
    '.editorial-banner__content', '.story__content', '.search-result-generic',
    '.collection-grid-premium__header', '.collection-toolbar',
    '.aw-manifesto__side', '.aw-manifesto__center', '.aw-manifesto__lower > *', '.aw-manifesto__ambition',
    '.aw-history__eyebrow', '.aw-history__title', '.aw-history__item', '.aw-history__quote'
  ].join(', ');
  root.classList.remove('no-js');
  root.classList.add('js', 'aw-motion-ready');

  function idle(callback) {
    if ('requestIdleCallback' in window) return window.requestIdleCallback(callback, { timeout: 700 });
    return window.setTimeout(callback, 1);
  }

  function prepareStaggers(scope = document) {
    scope.querySelectorAll('.aw-stagger').forEach((group) => {
      Array.from(group.children).forEach((child, index) => {
        child.style.setProperty('--aw-index', index);
        if (!child.matches(revealSelector)) child.classList.add('aw-reveal');
      });
    });
  }

  function prepareCommonReveals(scope = document) {
    scope.querySelectorAll(commonRevealSelector).forEach((element, index) => {
      if (!element.matches(revealSelector)) element.classList.add('aw-reveal');
      if (!element.style.getPropertyValue('--aw-delay')) element.style.setProperty('--aw-delay', `${Math.min((index % 4) * 70, 210)}ms`);
    });
  }

  function enhanceCommonElements(scope = document) {
    scope.querySelectorAll('.product-card, .product-card-v3, .card-wrapper, .article-card, .collection-card').forEach((card) => {
      card.classList.add('aw-hover-lift');
      const media = card.querySelector('.media, .card__media, .product-card__image, .product-card-v3__media');
      if (media) media.classList.add('aw-image-zoom');
    });
    scope.querySelectorAll('.button, .btn, button:not([data-aw-motion="off"])').forEach((button) => {
      if (!button.closest('.shopify-payment-button')) button.classList.add('aw-button-motion');
    });
  }

  function revealElement(element) {
    element.classList.add('is-visible');
    element.addEventListener('transitionend', () => { element.style.willChange = 'auto'; }, { once: true });
  }

  function revealImmediately(scope = document) { scope.querySelectorAll(revealSelector).forEach(revealElement); }
  let observer;
  function observe(scope = document) {
    const elements = scope.querySelectorAll(revealSelector);
    if (reducedMotionQuery.matches || !('IntersectionObserver' in window)) { revealImmediately(scope); return; }
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      }, { root: null, rootMargin: '0px 0px -7% 0px', threshold: 0.1 });
    }
    elements.forEach((element) => { if (!element.classList.contains('is-visible')) observer.observe(element); });
  }

  function init(scope = document) {
    prepareStaggers(scope);
    prepareCommonReveals(scope);
    observe(scope);
    idle(() => enhanceCommonElements(scope));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  reducedMotionQuery.addEventListener?.('change', () => { if (reducedMotionQuery.matches) revealImmediately(document); });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => { const block = event.target; if (block.matches(revealSelector)) revealElement(block); });
  window.AWAnimations = { version: '1.1.0', refresh: init, reveal: revealElement };
})();
